<template>
  <v-row>
    <v-col cols="12" :align="align">
      <div>
        <small v-if="message.visibility === 'LAB_ONLY'">
          Visible to {{ currentTenant.name }} only
        </small>
        <small v-if="message.visibility === 'LAB_AND_OSTEON'">
          Visible to {{ currentTenant.name }} and Osteon
        </small>
      </div>
      <v-card flat>
        <v-card-text class="pa-0">
          <v-chip
            v-if="message.note"
            :class="[
              'rounded-10 pa-2 text-left',
              message.direction === 'OUTBOUND'
                ? 'lighten-1'
                : 'font-weight-medium'
            ]"
            flat
            label
            dark
            :color="color"
            style="height: auto"
          >
            <span style="white-space: pre-wrap">
              <span>{{ message.note }}</span>
            </span>
          </v-chip>
        </v-card-text>
        <div class="my-2" v-if="message.attachments?.length > 0">
          <MessageAttachments :message="message" />
        </div>
      </v-card>
      <small>
        <span v-if="message.author_reference">
          <v-icon small> mdi-account </v-icon>
          {{
            message.direction === "INBOUND" &&
            message.visibility === "LAB_AND_OSTEON"
              ? `Osteon (${capitalise(
                  message.author_reference.slice(0, 2)
                )}...)`
              : message.author_reference
          }}
          -
        </span>
        {{ message.created_at | luxon({ output: "short" }) }}
      </small>
    </v-col>
  </v-row>
</template>

<script>
import MessageAttachments from "./MessageItem/MessageAttachments.vue"
import { mapGetters } from "vuex"
import { capitalise } from "@/utils"

export default {
  props: ["message"],

  components: { MessageAttachments },

  computed: {
    ...mapGetters(["currentTenant"]),

    align() {
      if (this.message.direction === "OUTBOUND") {
        return "right"
      }
      return "left"
    },

    color() {
      switch (this.message.visibility) {
        case "LAB_ONLY":
          return "success"
        case "LAB_AND_OSTEON":
          return "warning"
        default:
          return "secondary"
      }
    }
  },

  methods: {
    capitalise
  }
}
</script>
